import { type DatiTitolare } from '@framework/api-client/api/inquiries-compile/schemas/datiTitolare.ts';

export function mapApplicantToContext(
  applicant: DatiTitolare | null | undefined,
): Record<string, any> {
  return {
    nome: applicant?.nome,
    cognome: applicant?.cognome,
    email: applicant?.email,
    codiceFiscale: applicant?.codiceFiscale,
  };
}
